import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.css"
import { Helmet } from "react-helmet-async";
import { READBOOKS_URL } from "../../global-components/src/utils/vars";
import { isMyLove } from "../../global-components/src/utils/auth";
import { useAuth } from "../../global-components/src";

interface NotFoundProps {
  title?: string;
  text?: string;
  showLink?: boolean;
  children?: React.ReactNode;
}

/**
 * Componente de página 404 - Não encontrado
 * Exibe uma mensagem de erro e um link para voltar à home
 * @param {NotFoundProps} props - Propriedades do componente
 * @param {string} props.title - Título da página (opcional)
 */
export default function NotFound ({ title, text="Página não encontrada", showLink = true, children }: NotFoundProps) {
  const location = useLocation();
  const url = READBOOKS_URL + location.pathname.replace("/*", "");
  const { user } = useAuth();
  
  useEffect(() => {
        const root = document.getElementById("root");
        if (root) root.style.overflow = "hidden";
    
        return () => {
            if (root) root.style.overflow = "";
        };
    }, []);

  return (
      <>
        <div className="user-select-none container-404">
            <Helmet>
              <title>Paçoca - 404</title>
            </Helmet>
            
          <div className="col d-flex" style={{alignItems: "center", flexDirection: "column"}}>
              <h1 className="title-bold">{title}</h1>
              {children}
              <h3 style={{textAlign: "center"}}>{text}{isMyLove(user) ? ", meu amor" : ""} <br /> {showLink ? url : ""}</h3>
              {children ? "" : <img src="/img/errors/page-not-found.jpg" className="img-page-not-found"></img>}
              <Link to="/">Voltar para a Home</Link>
            </div>
        </div>
      </>
  );
};
